<button *ngIf="rounded"
        [class.border]="bordered !== undefined && bordered !== false"
        [color]="color"
        [disabled]="disabled"
        [style.height]="innerHeight"
        [style.width]="innerWidth"
        [type]="type"
        class="Button rounded"
        mat-fab>
    <mat-icon *ngIf="iconName"
              [class.mat-icon-white]="iconWhite"
              [class.reverse]="reverse !== undefined"
              [svgIcon]="iconName"></mat-icon>
    <ng-content></ng-content>
</button>

<button *ngIf="rounded === false"
        [class.border]="bordered !== undefined && bordered !== false"
        [color]="color"
        [disabled]="disabled"
        [style.height]="innerHeight"
        [style.width]="innerWidth"
        [type]="type"
        class="Button" mat-flat-button>
    <mat-icon *ngIf="iconName"
              [svgIcon]="iconName"></mat-icon>
    <ng-content></ng-content>
</button>